import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Star = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "m19.412 9.177-4.529 3.38 1.762 5.515a1.5 1.5 0 0 1-.507 1.649 1.36 1.36 0 0 1-1.659-.007L10 16.261l-4.479 3.453a1.36 1.36 0 0 1-1.659.007 1.5 1.5 0 0 1-.507-1.65l1.763-5.514-4.53-3.38a1.5 1.5 0 0 1-.52-1.645 1.5 1.5 0 0 1 1.336-1.05h5.492l1.765-5.459C8.847.414 9.388 0 10 0s1.153.414 1.339 1.023l1.873 5.46h5.384a1.5 1.5 0 0 1 1.335 1.049 1.5 1.5 0 0 1-.519 1.645" }) }));
});
Star.displayName = 'Star';
Star.__iconComponentType = 'standard';
export default Star;
//# sourceMappingURL=Star.js.map